import styled from 'styled-components';

import { pxToRem } from '../../lib/utils';

export const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: ${pxToRem(40)};
  padding-bottom: ${pxToRem(35)};
  text-align: center;
  background-color: ${({ theme }) => theme.colors.b};
  box-sizing: border-box;
`;

export const StyledHeading = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.e};
  font-family: ${({ theme }) => theme.fonts.headings};
  font-weight: 700;
  font-size: ${pxToRem(28)};
  line-height: ${pxToRem(36)};
`;

export const StyledSubHeading = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.brand};
  font-size: ${pxToRem(21)};
  font-weight: 700;
  line-height: ${pxToRem(32)};
`;
